import FamilyChoiceForm from '@/pages/FamilyChoiceForm.vue'
import ROUTE_NAMES from '@/constants/routeNames'

export default {
  path: '/wybieram/:familyEditionId/:warehouseId',
  props: true,
  name: ROUTE_NAMES.FAMILY_CHOICE_FORM,
  component: FamilyChoiceForm,
  meta: {
    title: 'Wybór Rodziny - formularz - Szlachetna Paczka',
    metaTags: [
      {
        name: 'robots',
        content: 'noindex, follow'
      }
    ]
  }
}
